// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"211":"589b82dc","281":"4de691f6","634":"aef853eb","683":"0f23c524","938":"f87ee688"}[chunkId] + ".chunk.css";
};